import { h, Component, Prop, Element, Host } from '@stencil/core';

import { getCSSVariable } from '../../../..';

@Component({
  tag: 'pk-tab-panel',
  styleUrl: './scss/pk-tab-panel.scss',
  shadow: true,
})
export class PkTabPanel {
  // Own Properties
  // ====================

  // Reference to host HTML element
  // ===================================

  @Element() el!: HTMLPkTabPanelElement;

  // State() variables
  // Inlined decorator, alphabetical order
  // =======================================

  // Public Property API
  // ========================

  /** Set the state selected for tab */
  @Prop({ reflect: true }) active: boolean = false;

  /** Set the tab id */
  @Prop({ reflect: true }) tab: string;

  /** Set the tab horizontal padding */
  @Prop({ reflect: true }) paddingX: string;

  /** Set the tab vertical padding */
  @Prop({ reflect: true }) paddingY: string;

  // Prop lifecycle events
  // =======================

  // Events section
  // Requires JSDocs for public API documentation
  // ==============================================

  // Component lifecycle events
  // Ordered by their natural call order
  // =====================================

  // Listeners
  // ==============

  // Public methods API
  // These methods are exposed on the host element.
  // Always use two lines.
  // Public Methods must be async.
  // Requires JSDocs for public API documentation.
  // ===============================================

  // Local methods
  // Internal business logic.
  // These methods cannot be called from the host element.
  // =======================================================

  // render() function
  // Always the last one in the class.
  // ===================================

  render() {
    const style = {
      ...(this.paddingX && {
        '--tab-panel--padding-x': getCSSVariable(this.paddingX),
      }),
      ...(this.paddingY && {
        '--tab-panel--padding-y': getCSSVariable(this.paddingY),
      }),
    };

    return (
      <Host class={{ active: this.active }} style={{ ...style }} role="tabpanel" aria-labelledby={this.tab}>
        <slot />
      </Host>
    );
  }
}
